import './FeedPageSideBar.css';
import logo from "../../Assets/logo.png";
import logo2 from "../../Assets/logo2.png";
import CustomDropdown from './CustomDropdown';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import LocationModal from '../../Navbar/LocationModal';
import NotificationPanel from './NotificationPanel';
import { API_BASE_URL } from '../../utils';

export default function FeedPageSideBar({ setShowSideBar, notif }) {
    const url = `${API_BASE_URL}/master/assets/uploads/`;
    const userdata = JSON.parse(localStorage.getItem("userData"));

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [locationModal, setLocationModal] = useState(false);
    const [userLocation, setUserLocation] = useState("Select Location");
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);


    const handleItemClick = () => {
        if (typeof setShowSideBar === "function") {
            setShowSideBar(false);
        } else {
            console.warn("setShowSideBar not provided");
        }
    };

    useEffect(() => {
        const handleResize = () => {
            setIsCollapsed(window.innerWidth >= 1050);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Load once on mount
    useEffect(() => {
        try {
            const stored = localStorage.getItem("userLocation");
            if (stored) setUserLocation(stored);
        } catch { }
    }, []);

    // Persist whenever it changes
    useEffect(() => {
        try {
            if (userLocation && userLocation !== "Select Location") {
                localStorage.setItem("userLocation", userLocation);
            }
        } catch { }
    }, [userLocation]);

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    const handleHelpCenter = () => {
        window.open('https://wa.me/+918299619469', '_blank');
    };

    const sidebarItems = [
        { label: "Home", icon: "fi fi-rr-home", path: "/" },
        { label: "Search", icon: "fi fi-rr-search", path: "/result" },
        { label: "My Booking", icon: "fi fi-sr-rotate-right", path: "/my-bookings" },
        { label: "My Plan", icon: "fi fi-rs-memo", path: "/my-plan" },
        { label: "Notifications", icon: "fi fi-rs-bell" },
        { label: "Select Location", icon: "fi fi-rr-marker" },
        { label: "Saved Items", icon: "fi fi-rr-bookmark" },
        { label: "Favourites", icon: "fi fi-tr-circle-star", path: "/favourite-club" },
        { label: "Dark Mode", icon: "fi fi-rr-brightness" }
    ];

    return (
        <div className={`feed-sidebar-section ${isCollapsed ? 'collapsed' : ''}`}>
            <div className='feed-sidebar-container-section'>
                <div className='feed-sidebar-toggle' onClick={() => setIsCollapsed(!isCollapsed)}>
                    <i className={`fi ${isCollapsed ? 'fi-br-angle-right' : 'fi-br-angle-left'}`}></i>
                </div>

                <Link to="/" onClick={handleItemClick}>
                    <div className='feed-sidebar-logo'>
                        {!isCollapsed ? (
                            <img src={logo} alt="Logo" />
                        ) : (
                            <img src={logo2} alt="Logo" />
                        )}
                    </div>
                </Link>

                {sidebarItems.map((item, index) => {
                    if (item.path) {
                        return (
                            <Link
                                to={item.path}
                                key={index}
                                style={{ textDecoration: 'none', color: 'black' }}
                                onClick={handleItemClick}
                            >
                                <div className="feed-sidebar-list-items">
                                    <i className={item.icon}></i>
                                    {!isCollapsed && <span>{item.label}</span>}
                                </div>
                            </Link>
                        );
                    } else {
                        if (item.label === "Select Location") {
                            return (
                                <div
                                    className="feed-sidebar-list-items"
                                    key={index}
                                    onClick={() => {
                                        setLocationModal(true);
                                        handleItemClick();
                                    }}
                                >
                                    <i className={item.icon}></i>
                                    {!isCollapsed && (
                                        <span>
                                            {userLocation.length > 20
                                                ? userLocation.slice(0, 20) + "..."
                                                : userLocation}
                                        </span>
                                    )}
                                </div>
                            );
                        } else if (item.label === "Notifications") {
                            return (
                                <div
                                    data-tooltip-content="Notifications"
                                    data-tooltip-id="notification-tooltip"
                                    className={`feed-sidebar-list-items ${notif?.length > 0 ? "has-notif" : ""}`}
                                    key={index}
                                    onClick={() => {
                                        setShowNotificationPanel(true);
                                        handleItemClick();
                                    }}
                                >
                                    <i className={item?.icon}></i>

                                    {/* Sidebar label */}
                                    {!isCollapsed && <span>{item?.label}</span>}

                                    {/* Notification badge */}
                                    {notif?.length > 0 && (
                                        <span className="notif-badge">
                                            {notif?.length > 9 ? "9+" : notif?.length}
                                        </span>
                                    )}
                                </div>

                            );
                        } else {
                            return (
                                <div
                                    className="feed-sidebar-list-items"
                                    key={index}
                                    onClick={handleItemClick}
                                >
                                    <i className={item?.icon}></i>
                                    {!isCollapsed && <span>{item?.label}</span>}
                                </div>
                            );
                        }
                    }
                })}

                <CustomDropdown
                    isCollapsed={isCollapsed}
                    triggerLabel={
                        isCollapsed ? (
                            <span><i className="fi fi-br-menu-dots"></i></span>
                        ) : (
                            <span>
                                <i className="fi fi-br-menu-dots" style={{ marginRight: "10px" }}></i>
                                More items
                            </span>
                        )
                    }
                    options={[
                        { label: 'Help Center', icon: 'fi fi-rr-question', onClick: handleHelpCenter },
                        ...(userdata ? [{
                            label: 'Logout',
                            icon: 'fi fi-rr-sign-out-alt',
                            onClick: handleLogout
                        }] : [])
                    ]}
                />
            </div>

            <div className='feed-sidebar-profile-box'>
                {userdata ? (
                    <div className='feed-sidebar-profile-image-box-wrapper'>
                        <div className='feed-sidebar-profile-image'>
                            <img src={url + userdata?.img} alt="Profile" />
                        </div>
                        {!isCollapsed && (
                            <div className='feed-sidebar-profile-name'>
                                <h1>{userdata?.name}</h1>
                                <p>Profile</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <Link to="/login" onClick={handleItemClick}>
                        Login/SignUp
                    </Link>
                )}
                {!isCollapsed && <i className="fi fi-br-angle-down"></i>}
            </div>

            {locationModal && (
                <LocationModal
                    isOpen={locationModal}
                    onClose={() => setLocationModal(false)}
                    onSelectLocation={(location) => {
                        setUserLocation(location);
                        setLocationModal(false);
                    }}
                />
            )}

            <NotificationPanel
                isOpen={showNotificationPanel}
                onClose={() => setShowNotificationPanel(false)}
                notifications={notif}
            />
        </div>
    );
}
